const CatalogVerticalSimpleComponent = {
    data() {
        return {
            products: [],
            loading: false,
            perPage: 20,
            addingToCart: null,
            updateTimeouts: new Map(),
            favoriteTimeouts: new Map(),
        }
    },
    methods: {
        async getProducts() {
            this.loading = true;

            try {

                const response = await window.productHelpers.getProducts({
                    limit: 5
                });

                this.products = response.data ?? [];

                if (window.cartHelpers && !window.globalState.isAuth) {
                    window.cartHelpers.initializeProductCartState(this.products);
                }

            } catch (error) {

                this.messageError = "Ошибка сети";

            } finally {

                this.loading = false;

            }
        },

        async updateCartQuantity(product, change, value) {
            await window.cartHelpers.updateCartQuantity(this, product, change, value);
        },

        async addToCart( product ) {
            await window.cartHelpers.addToCart(this, product);
        },

        async updateProductFavorite(product) {
            await window.favoriteHelpers.updateProductFavorite(this, product);
        },

        updateProductSubscribe(product) {
            window.subscribeHelpers.updateProductSubscribe(this, product);
        },

        handleInputMouseDown(event) {
            window.inputHelpers.handleInputMouseDown(event);
        },

        formatPrice( price ) {
            return window.globalState.formatPrice(price);
        },

    },
    mounted() {
        this.getProducts();
    },
    computed: {
        showLoading() {
            return this.loading;
        },
        showContent() {
            return !this.loading && this.products && this.products.length > 0;
        }
    }
};

window.CatalogVerticalSimpleComponent = CatalogVerticalSimpleComponent;